import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.min.css';

var styles = {"bold":"panneau-element-icon-bold","opaque":"panneau-element-icon-opaque"};

var _excluded = ["name", "bold", "opaque", "className"];
var propTypes = {
  name: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  opaque: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  bold: false,
  opaque: false,
  className: null
};
var Icon = function Icon(_ref) {
  var name = _ref.name,
    bold = _ref.bold,
    opaque = _ref.opaque,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return name === 'loading' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "spinner-border spinner-border-sm",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden",
    role: "status"
  }, "Loading...")) : /*#__PURE__*/React.createElement("i", Object.assign({
    className: classNames(["bi-".concat(name)], _defineProperty(_defineProperty(_defineProperty({}, styles.bold, bold), styles.opaque, opaque), className, className !== null))
  }, props));
};
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export { Icon as default };
